import React, { FC } from 'react'
import { Tags } from 'components'
import { format } from '@dt/fe-utils'
import './productsList.scss'

interface IProps {
  isSelect: boolean;
  product: any;
  memberCouponId: number;
  onUseClick: (coupon: any) => void;
  /** 是否是删除样式 */
  // isDelete?: boolean;
  /** 是否是优惠码 */
  // isPromoCode?: boolean;
  // selectItemCouponMap?: any;
}

const ProductsItem: FC<IProps> = ({
  isSelect,
  product,
  memberCouponId,
  onUseClick,
}) => {
  const handleProductSelect = (product) => {
    onUseClick({
      memberCouponId,
      pk: product.pk
    })
  }
  // const isSelect = selectItemCouponMap?.[memberCouponId] === product.pk
  // console.log(memberCouponId, selectItemCouponMap[memberCouponId], product.pk, 'ProductsItemProductsItemProductsItem', product)
  // const isSelectCnt = selectItemCouponMap && Object.values(selectItemCouponMap).filter(id => { return id === product.pk })
  // console.log(isSelectCnt, 'isSelectCntisSelectCntisSelectCntisSelectCntisSelectCntisSelectCntisSelectCntisSelectCnt')
  // const disabled = !isSelect && isSelectCnt.length === product.cnt
  return (
    <div className='product-item' onClick={() => handleProductSelect(product)}>
      {/* <div className='product-img'>
        <img src={product?.pic} alt='' />
      </div> */}
      <div className='product-img' style={{ backgroundImage: product?.pic ? `url(${product?.pic})` : 'none' }}>
        {
          !product.pic && <i className='iconfont icon-meishi default-span'></i>
        }
      </div>
      <div className='product-info'>
        <div className='product-info-base'>
          <div className='name'>{product.name}</div>
          <div className='price'>{format.toPrice(product.unitPrice)}</div>
        </div>
        <div className='product-info-desc'>{product?.optionStr}</div>
        <div className='product-info-tags'>
          <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} />
        </div>
      </div>
      <div className='product-operate'>
        <div className={`select-mark ${isSelect ? 'has-select' : 'no-select'}`}>
          {isSelect ? <i className='iconfont icon-checked'></i> : <></>}
        </div>
        {/* <div className='select-mark has-select'>
          <i className='iconfont icon-checked'></i>
        </div> */}
      </div>
    </div>
  )
}

export default ProductsItem
